import { render } from "./BLTooltip.vue?vue&type=template&id=3cc09015&scoped=true"
import script from "./BLTooltip.vue?vue&type=script&lang=js"
export * from "./BLTooltip.vue?vue&type=script&lang=js"

import "./BLTooltip.vue?vue&type=style&index=0&id=3cc09015&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cc09015"]])

export default __exports__